// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__7ZMqq","error":"Textarea_error__3ZHTS","readonly":"Textarea_readonly__d7-ik","disabled":"Textarea_disabled__hAAwy"};